import { render, staticRenderFns } from "./cheliang.vue?vue&type=template&id=b07ea444&scoped=true"
import script from "./cheliang.vue?vue&type=script&lang=js"
export * from "./cheliang.vue?vue&type=script&lang=js"
import style0 from "./cheliang.vue?vue&type=style&index=0&id=b07ea444&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07ea444",
  null
  
)

export default component.exports